"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgAppleDark = function () { return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.268 5.247c.649-.842 1.14-2.032.963-3.247-1.061.074-2.301.756-3.025 1.645-.66.806-1.201 2.004-.99 3.167 1.16.037 2.357-.662 3.052-1.565ZM20 16.674c-.464 1.04-.688 1.504-1.285 2.425-.834 1.285-2.01 2.886-3.47 2.897-1.294.014-1.628-.852-3.385-.842-1.758.01-2.124.859-3.421.846-1.458-.013-2.572-1.457-3.406-2.742-2.334-3.592-2.58-7.808-1.14-10.05C4.916 7.615 6.53 6.684 8.048 6.684c1.543 0 2.515.856 3.793.856 1.24 0 1.995-.858 3.78-.858 1.352 0 2.784.744 3.803 2.028-3.34 1.851-2.8 6.674.576 7.964Z", fill: "#333333" })); };
exports.default = factorySvgIcon_1.default(SvgAppleDark);
//# sourceMappingURL=SvgAppleDark.js.map